module.exports = __webpack_public_path__ + "ClientApp/images/content/Student_Externship_Masthead.png";